import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { ActivatedRoute, ParamMap } from '@angular/router'
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { ValidatorUtils } from '../core/_util/validator-util';
import { NullVisitor } from '@angular/compiler/src/render3/r3_ast';

@Component({
  selector: 'app-procesos',
  templateUrl: './procesos.component.html',
  styleUrls: ['./procesos.component.scss']
})
export class ProcesosComponent extends ValidatorUtils  implements OnInit {

  @Input() fichaActual : any;

  listaDocumentos : any;
  formBuilder: FormBuilder;
  formulario: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;
  listaAsignadosDocumentos : any;
  procesos: any;

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService
  ) {
    super();
    this.formBuilder = new FormBuilder();
    this.formulario = this.formBuilder.group({
      procesos:['',Validators.required], 
    });
   
  }


  ngOnInit(): void {
    this.getListaDocumentos();
    if (this.fichaActual != null && this.fichaActual != undefined){
      this.getListaDocumentosAsignados();
    }
    
  
  }


  getListaDocumentosAsignados(){

    let params = {
      fichaActual: this.fichaActual
    }
    this.coreService.getWithParams('/listar-documentos', params).subscribe(
      (res: any) => {
        console.log(res);
        this.formulario.controls['procesos'].setValue(res);
      },
      (err: any) => {
      }
    )
  }


  getListaDocumentos() {
    this.coreService.get('/obtenerValidaciones').subscribe(
      (res: any) => {
        this.listaDocumentos = res.documentos;
       
      },
      (err: any) => {
        console.log(err);
      }
    )
  }


  guardar() {
    var dat = this.formulario.valid;

    this.formulario.markAllAsTouched();
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea guardar este registro?',
        accept: () => {
          this.submitted = true;
          this.guardarListado();
          
        }
      });
    }
  }


  guardarListado() {
    
   
    let params = {
      registros: this.formulario.value.procesos,
      fichaActual: this.fichaActual
    }
    this.coreService.post('/guardar-documentos', params).subscribe(
      (res: any) => {
        this.msj.info(res);
      },
      (err: any) => {
      }
    )
  }



}
